import { useInboxNotifications, useMarkInboxNotificationAsRead } from '@liveblocks/react'

import { useGetRoomByAssessmentId } from '@/api/assessments.hook'

export const useUnreadAssessmentComments = (assessmentId: string) => {
  const { roomId } = useGetRoomByAssessmentId(assessmentId)
  const { inboxNotifications } = useInboxNotifications({ query: { roomId } })
  const markAsRead = useMarkInboxNotificationAsRead()

  const unread = roomId ? (inboxNotifications ?? []).filter(({ readAt }) => !readAt) : []

  return {
    hasUnread: unread.length > 0,
    markAllAsRead: () => unread.forEach(({ id }) => markAsRead(id)),
  }
}
